import React from 'react';
import { FormattedMessage } from 'react-intl';
import browserHistory from 'react-router/lib/browserHistory';
import CSSModules from 'react-css-modules';
import Button from '../Button';
import { AUTH } from '../../constants/strings';
import { HEALTHBOARD } from '../../constants/routes';
import styles from './index.styl';
import MetaHelmet from '../AppHelmet/MetaHelmet';
import { usePageView } from '../../hocs/usePageView';

const ExpiredConfirmation = () => {
  usePageView('Expired Confirmation');
  return (
    <div styleName="formWrapper">
      <MetaHelmet title="pages.title.expiredConfirmation" />

      <p styleName="formTitle">
        <FormattedMessage {...AUTH.titles.expiredConfirmation} />
      </p>
      <p styleName="formText" className="mb4">
        <FormattedMessage {...AUTH.actions.expiredConfirmation.textTitle} />
      </p>
      <Button
        className="db w-100"
        color="primary"
        raised
        onClick={() => browserHistory.push(`/${HEALTHBOARD}`)}
      >
        <FormattedMessage {...AUTH.submit.expiredToken} />
      </Button>
    </div>
  );
};

export default CSSModules(ExpiredConfirmation, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Auth/ExpiredConfirmation.jsx